import { Bell } from 'lucide-react';
import { IconButton } from '../actions/IconButton';
import { CountBadge } from '../data-display/CountBadge';
import { useActivityStore } from '../../store/useActivityStore';

/**
 * The activity bell (topbar, right). The unread count arrives over the
 * activity-count WebSocket (services/wsService) — every notification,
 * event and alert sent to the signed-in company profile lands as an activity.
 */
export function ActivityBell({ onClick }: { onClick: () => void }) {
  const activityCount = useActivityStore((s) => s.activityCount);
  return (
    <span className="relative inline-flex">
      <IconButton ariaLabel="Open activity" tone="warm" onClick={onClick}>
        <Bell size={20} strokeWidth={2} aria-hidden="true" />
      </IconButton>
      <CountBadge count={activityCount} className="absolute -right-0.5 -top-0.5" />
    </span>
  );
}
